// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1151":"e335b6e4249f184a","1483":"aa7ed8b47a9a70ba","2888":"44dae721f09f5604"}[chunkId] + ".css";
};